import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import RulesSection from "../components/Rules/RulesSection";

function Rules() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Rules | SAAC Basketball Quito 2026</title>
        <meta
          name="description"
          content="Official tournament rules for SAAC Basketball Quito 2026."
        />
      </Helmet>

      <RulesSection />
    </>
  );
}

export default Rules;